// extracted by mini-css-extract-plugin
export default {"cell":"cell_cell__8FFrN","headerCell":"cell_headerCell__LvymA"};